import { render, staticRenderFns } from "./PageCategoria.vue?vue&type=template&id=0841528d&"
import script from "./PageCategoria.vue?vue&type=script&lang=js&"
export * from "./PageCategoria.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/silo.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports